export default {
    title: 'Trợ lý MoonGroup',
    welcome: {
        greeting: 'Xin chào! Tôi có thể trả lời câu hỏi về MoonGroup — dịch vụ, sản phẩm và cách chúng tôi làm việc.',
        hint: 'Thử một trong các câu hỏi sau hoặc hỏi bất cứ điều gì:',
    },
    examplePrompts: [
        'Bạn cung cấp những dịch vụ gì?',
        'Cho tôi biết về sản phẩm của bạn',
        'Một dự án điển hình mất bao lâu?',
        'Làm sao để liên hệ với bạn?',
    ],
    composer: {
        placeholder: 'Hỏi bất cứ điều gì…',
        send: 'Gửi',
        hint: 'Enter để gửi, Shift+Enter để xuống dòng',
        charCount: '{used}/{max}',
    },
    states: {
        thinking: 'Đang suy nghĩ…',
        offline: 'Tôi tạm thời ngoại tuyến — vui lòng thử lại sau ít phút.',
        rateLimited: 'Hơi nhanh đấy — đợi một chút rồi thử lại.',
        error: 'Đã xảy ra lỗi. Thử lại?',
        paused: 'Cuộc trò chuyện tạm dừng một lúc — vui lòng thử lại sau.',
        inputRejected: 'Không thể gửi tin nhắn đó. Vui lòng diễn đạt lại và thử lại.',
        scrollToBottom: 'Tin nhắn mới',
    },
    toast: {
        replyReady: 'Trợ lý đã trả lời',
        leadSent: 'Đã gửi cho đội ngũ — chúng tôi sẽ liên hệ',
    },
    actions: {
        expand: 'Mở rộng',
        collapse: 'Thu gọn',
        close: 'Đóng',
        retry: 'Thử lại',
        openChat: 'Mở trò chuyện',
        askAi: 'Hỏi AI',
    },
};
